import { AfterViewInit, ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ITEM_REVENUE_CATEGORY } from 'src/app/helpers/item-revenue.helper';
import { LENS_OPTIONS_TYPES } from 'src/app/helpers/lens-options.helper';
import { ORDER_CATEGORY } from 'src/app/helpers/order-categories.helper';
import { CompanyLensOptions } from 'src/app/models/company-lens-options.model';
import { ProductDataSubject } from 'src/app/models/product-data-subject.model';
import { ItemDetailsRequest } from 'src/app/models/requests/item-details-request.model';
import { CompanyLensOptionsVM } from 'src/app/models/view-models/company-lens-options-vm.model';
import { CartManagerService } from 'src/app/services/local/cart-manager.service';
import { OrderManagerService } from 'src/app/services/local/order-manager.service';
import { CompanyComputerLensOptionsService } from 'src/app/services/repositories/company-computer-lens-options.service';
import { CompanyDressLensOptionsService } from 'src/app/services/repositories/company-dress-lens-options..service';
import { CompanyLensOptionsService } from 'src/app/services/repositories/company-lens-options.service';
import { CompanyRespiratorLensOptionsService } from 'src/app/services/repositories/company-respirator-lens-options.service';

@Component({
    selector: 'app-coatings',
    templateUrl: './coatings.component.html',
    styleUrls: ['./coatings.component.scss'],
    standalone: false
})
export class CoatingsComponent implements OnInit, AfterViewInit {
  toggleClass: boolean = true;
  optionSelected: boolean = false;

  currentParentClass = "lens-module";
  companyLensOptionsVM: CompanyLensOptionsVM[] = [];
  selectedLensOption: CompanyLensOptionsVM | undefined;
  tempCartEventsSubject: Subject<ProductDataSubject> = new Subject<ProductDataSubject>();
  isEditMode: boolean = false;
  queryParams: {} = {};

  @ViewChildren('option') optionElements!: QueryList<any>;

  constructor(private _router: Router,
              private _route: ActivatedRoute,
              private _changeDetectionRef: ChangeDetectorRef,
              private _orderManagerService: OrderManagerService,
              private _companyLensOptionsService: CompanyLensOptionsService,
              private _companyDressLensOptionsService: CompanyDressLensOptionsService,
              private _companyRespiratorLensOptionsService: CompanyRespiratorLensOptionsService,
              private _companyComputerLensOptionsService: CompanyComputerLensOptionsService,
              private _cartManagerService: CartManagerService) { }


  ngOnInit(): void {
    this._route.queryParams
    .subscribe(params => {
      this.isEditMode = params.isEditMode === 'true';
      this.queryParams = this.isEditMode ? {'isEditMode' : this.isEditMode} : {};
      this.getCoatingOptions();
    });
  }

  ngAfterViewInit() {
    this.optionElements.changes.subscribe(ql => {
      this._orderManagerService
        .preSelectLensOptionItems(ql, this.isEditMode, this.companyLensOptionsVM);
      // manually detect changes is needed when onclick is submitted programatically
      this._changeDetectionRef.detectChanges();
		});
  }

  switchClass(selectedName: string) {
    this.currentParentClass = selectedName;
    this.optionSelected = true;
  }

  getCoatingOptions() {
    const cartItem = this._cartManagerService.getTempCartItem();
    let lensObservable: any;
    if (cartItem) {
      switch (cartItem?.itemCategory) {
        case ORDER_CATEGORY.glasses:
          lensObservable = this._companyLensOptionsService.getLensOptions(LENS_OPTIONS_TYPES.coatings);
          break;
        case ORDER_CATEGORY.computerGlasses:
          lensObservable = this._companyComputerLensOptionsService.getLensOptions(LENS_OPTIONS_TYPES.coatings);
          break;
        case ORDER_CATEGORY.dressGlasses:
          lensObservable = this._companyDressLensOptionsService.getLensOptions(LENS_OPTIONS_TYPES.coatings);
          break;
        case ORDER_CATEGORY.respiratorInserts:
          lensObservable = this._companyRespiratorLensOptionsService.getLensOptions(LENS_OPTIONS_TYPES.coatings);
          break;
        default:
          this.redirectToDashboard();
      }
      lensObservable.subscribe((data: CompanyLensOptions[]) => {
        if (data) {
          this.populateLensOptionData(data);
        }
      }, (error: any) => {
        console.log(error);
      });
    }
    else {
      this.redirectToDashboard();
    }
  }

  redirectToDashboard() {
    this._router.navigate(['/dashboard']);
  }

  populateLensOptionData(data: CompanyLensOptions[]) {
    Object.assign(this.companyLensOptionsVM, data);
  }

  selectLensOption(lensOptionId: string) {
   const optionId = parseInt(lensOptionId);
   if (this.selectedLensOption?.lensOptionId !== optionId) {
    this.selectedLensOption = this.companyLensOptionsVM
    .find(clovm => clovm.lensOptionId == optionId);
     if (this.selectedLensOption) {
       this.switchClass(`option${lensOptionId} selected`);
       if (this.selectedLensOption) {
         this.saveLensOption();
       }
     }
   }
  }

  saveLensOption() {
    if (this.selectedLensOption) {
      const cartItemDetail : ItemDetailsRequest = {
        id: this.selectedLensOption.lensOptionId,
        itemType: ITEM_REVENUE_CATEGORY.lensTreatment,
        itemSubType: LENS_OPTIONS_TYPES.coatings,
        itemDescription: this.selectedLensOption.lensOptionName
      };

      this._cartManagerService.updateTempCartItemDetail(cartItemDetail);
      this.emitChangeToProductData();
    }
  }

  removeLensOption() {
    this.switchClass('noTintsTransitions')
    this.clearSelectedOption();
    this._cartManagerService.removeTempCartItemDetail(ITEM_REVENUE_CATEGORY.lensTreatment, LENS_OPTIONS_TYPES.coatings);
    this.emitChangeToProductData();
  }

  clearSelectedOption() {
    this.selectedLensOption = undefined;
  }

  emitChangeToProductData() {
    let pds: ProductDataSubject = { status: 'lens-options-update' };
    this.tempCartEventsSubject.next(pds);
  }

}
